import React, { useState, useEffect } from "react";
import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBCollapse,
  MDBIcon,
} from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import Logo from "../img/ElanaNewLogo.png";
import "../styles/index.css";
import { logout, reset } from "../features/auth/authSlice"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux";
import arrow from "../img/next.png"
// import  arrow  from "../../src/img/link.png"

export const Navbar = () => {
  const [showNav, setShowNav] = useState(false);
  const dispatch = useDispatch()

  const { user } = useSelector((state) => state.auth)

  const onLogout = () => {
    dispatch(logout())
    dispatch(reset())
    localStorage.removeItem('token')
  }

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  return (
    <MDBNavbar expand="lg" className="d-flex navWrapper sticky-top">
      <Link to="/">
        <MDBNavbarBrand>
          <img src={Logo} className="logo" alt="Elana Logo" />
        </MDBNavbarBrand>
      </Link>
      <MDBNavbarToggler
        className="toggler"
        type="button"
        aria-expanded="false"
        aria-label="Toggle navigation"
        onClick={() => setShowNav(!showNav)}
      >
        <MDBIcon icon="bars" fas />
      </MDBNavbarToggler>

      {/* TWO NAVBARS ONE FOR DESKTOP AND MOBILE (SWITCH AFTER A CERTAIN WIDTH) */}
      {windowDimensions.width >= 992 ?
       <MDBCollapse navbar show={showNav} className="bg-responsive-white">
        <MDBNavbarNav right fullWidth={false} >
          {user && <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/newPractitionerProfile" className="link fix">
                <div className="responsive-grey" >
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">My Profile</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>}
          {user?.role === "ADMIN" && <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/admin" className="link fix">
                <div className="responsive-grey" >
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Admin</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>}
          <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/Individual" className="link fix">
                <div className="responsive-grey "  >
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Individuals</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>
          <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/pelvicCareProgram" className="link fix">
                <div className="responsive-grey" >
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Pelvic Program</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>
          <MDBNavbarItem>
            <MDBNavbarLink className="">
              <Link to="/Practitioner" className="link fix">
                <div className="responsive-grey" >
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Practitioners</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>

          <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/browse" className="link fix">
                <div className="responsive-grey" >
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Browse</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>

          {/* {!user && <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/practitionerSignUp" className="link fix">
                <div className="responsive-grey">
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Join</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>} */}
          <MDBNavbarItem>
            <MDBNavbarLink className="move-r">
              <div className="responsive-grey margin-top-responsive " >
                <a
                  className="link2 fix"
                  href="https://www.myelana.com/blog"
                  target="_blank"
                  rel="noreferrer"

                >
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Blog</p>
                </a>
                <img src={arrow} alt="arrow" className="icon-responsive" />
              </div>
            </MDBNavbarLink>
          </MDBNavbarItem>
          <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/about" className="link fix">
                <div className="responsive-grey" >
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">About</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>
          <MDBNavbarItem className="last-nav-item">
            <MDBNavbarLink>
              {/* Need to fix this doesn't make proper sense */}
              <Link to={user ? "/" : "/practitionerLogin"} className="link fix">
                <div className="responsive-grey" >
                  {user ? <p className="m-0 fs-16 blue-hover-navbar text-dm" onClick={() => {
                    onLogout()
                  }}>Logout</p> : <p className="m-0 fs-16 blue-hover-navbar text-dm">Login</p>
                  }
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>
        </MDBNavbarNav>
      </MDBCollapse> : <MDBCollapse navbar show={showNav}>


      {/* //here start the other one */}
        <MDBNavbarNav right fullWidth={false} >
          {user && <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/newPractitionerProfile" className="link fix">
                <div className="responsive-grey" onClick={() => setShowNav(!showNav)}>
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">My Profile</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>}
          {user?.role === "ADMIN" && <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/admin" className="link fix">
                <div className="responsive-grey" onClick={() => setShowNav(!showNav)}>
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Admin</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>}
          <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/Individual" className="link fix">
                <div className="responsive-grey" onClick={() => setShowNav(!showNav)} >
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Individuals</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>
          <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/pelvicCareProgram" className="link fix">
                <div className="responsive-grey" onClick={() => setShowNav(!showNav)}>
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Pelvic Program</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>
          <MDBNavbarItem>
            <MDBNavbarLink className="">
              <Link to="/Practitioner" className="link fix">
                <div className="responsive-grey" onClick={() => setShowNav(!showNav)}>
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Practitioners</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>

          <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/browse" className="link fix">
                <div className="responsive-grey" onClick={() => setShowNav(!showNav)}>
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Browse</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>
          

          {/* {!user && <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/practitionerSignUp" className="link fix">
                <div className="responsive-grey">
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Join</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>} */}
          <MDBNavbarItem>
            <MDBNavbarLink className="move-r">
              <a
                className="link2 fix"
                href="https://www.myelana.com/blog"
                target="_blank"
                rel="noreferrer"

              >
                <div className="responsive-grey margin-top-responsive " onClick={() => setShowNav(!showNav)}>
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">Blog</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </a>
            </MDBNavbarLink>
          </MDBNavbarItem>
          <MDBNavbarItem>
            <MDBNavbarLink>
              <Link to="/about" className="link fix">
                <div className="responsive-grey" onClick={() => setShowNav(!showNav)}>
                  <p className="m-0 fs-16 blue-hover-navbar text-dm">About</p>
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>
          <MDBNavbarItem className="last-nav-item">
            <MDBNavbarLink>
              {/* Need to fix this doesn't make proper sense */}
              <Link to={user ? "/" : "/practitionerLogin"} className="link fix">
                <div className="responsive-grey" onClick={() => setShowNav(!showNav)}>
                  {user ? <p className="m-0 fs-16 blue-hover-navbar text-dm" onClick={() => {
                    onLogout()
                  }}>Logout</p> : <p className="m-0 fs-16 blue-hover-navbar text-dm">Login</p>
                  }
                  <img src={arrow} alt="arrow" className="icon-responsive" />
                </div>
              </Link>
            </MDBNavbarLink>
          </MDBNavbarItem>
        </MDBNavbarNav>
      </MDBCollapse>}
    </MDBNavbar>
  );
};


